import { Component, Input, SimpleChanges } from '@angular/core';
import * as _ from 'lodash';
import * as Highcharts from 'highcharts';
import { HttpClient } from '@angular/common/http';
import { TableViewService } from '../../table-view.service';;
import { Observable, Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomsnapshotService } from 'src/app/modules/snapshot/Services/customsnapshot.service';
import { COMMON_CONSTANTS, COMMON_CONSTANTS_Percentage, COMMON_CONSTANTS_SNAPSHOT } from 'src/app/common/constants/common-constants';
import { SnapshotService } from 'src/app/modules/snapshot/Services/snapshot.service';
import { LoaderService } from 'src/app/common/services/loader.service';
@Component({
  selector: 'app-line-or-trend-custom',
  template: `<div [id]="'chart-container'+id" [ngStyle]="{'height': popUp ? '30em' : 'calc(100% - 3rem)'}" [style]="'height:'+height"></div>`
})
export class LineortrendComponentCustom {
      LowBaseSample = COMMON_CONSTANTS.LowBase_Sample;
    InsufficientBaseSample = COMMON_CONSTANTS.InsufficientBase_Sample;
     insufficientBase: string = '20';
    LowBase: string = '40';
  @Input() brandSelected: any = "";
  @Input() metricSelected: any = "";
  data: any;
  LineChartData: any[] = [];
  ChartProperties: any;
  categoriesList: any;
  updateCategoryName: any = [];
  colorCodeList: any[] = [];
  seriesData: any[] = [];
  chart: any;
  custom: any[] = [];
  event: any;
  changeValue: any[] = [];
  significanceValue: any;
  sampleSizeValues: any[] = [];
  actualDataValue: any[] = [];
  chartCategories: any;
  samplesizeConstantValue = 1000;
  chartMinAxis: any;
  chartMaxAxis: any;
  isAudienceSnapshot :boolean = false;
  showLowSample: any;
  userselectedchartdata: any;
  tickInterval = 10;
   chartMainData: any = [];
  tickIntervalForStacking = 50;
  configuredProperties: any;
     selectedMetric: any = '';
  @Input() trendData: any;
  @Input() Top10Toggle: any = false;
  @Input() DataLabelOn: any;
  @Input() isOutput: any;
  @Input() gridTempleteColumns: any;
  @Input() popUpp: any;
  @Input() popUp: any;
  @Input() customData: any;
  @Input() id: any = 0;
  @Input() sort: any;
  @Input() WidgetDetails: any;
   globalColorMap: { [key: string]: string } = {};
     private serviceSubscriptions: Subscription = new Subscription();
  constructor(public http: HttpClient,    private loader: LoaderService,public LineTrendService: TableViewService, private _customSnapshotService: CustomsnapshotService,private router: Router,private route: ActivatedRoute, private _configService: SnapshotService) { }
  @Input() height: any = "24em";
  private initialized = false;
  ngOnInit(): void {    
    this.isAudienceSnapshot =
    this._configService.selectedSnapshotType
      ?.toLowerCase()
      ?.includes('audience');
       this.serviceSubscriptions.add(
      this._configService.globalColorMap$.subscribe((map) => {
        if (map) {
          this.globalColorMap = map;
          // re-prepare series and redraw to apply new colors
          try {
            this.prepareSeriesDataForChart();
            if (this.chart) this.plotLineChart('chart-container');
          } catch (e) {}
        }
      })
    );
    if (this.isOutput) {
      this.configuredProperties = JSON.parse(this.customData.customizationProperties);
      this.customData = this.customData.metric[0];
      this.customData.metric_value.sort((a: any, b: any) => (a.selectOrder ?? a.selectorder ?? 0) - (b.selectOrder ?? b.selectorder ?? 0));
      this.subscriptions.add(
        this._configService.confedenceValue.subscribe((value) => {
          this.DefaultConfidenceLevel = value;
          this.updatesig();
        }));
      this.subscriptions.add(
        this._configService.significanceValue.subscribe((value) => {
          this.significanceValue = value;
          this.updatesig();
        }));
          this.subscriptions.add(
        this._customSnapshotService.getSelectedMetric(this.id).subscribe((selectedMetric) => {
          this.selectedMetric = selectedMetric || '';
          this.updatesig();
        }));

    }
    else {
      //this.categoriesList = ["Oct'2023", "Nov'2023", "Dec'2023", "Jan'2024", "Feb'2024"]
      this.http.get<any>('assets/Data/TrendChartData.json').subscribe(jsonData => {
        this.data = jsonData[0];
        this.LineChartData = jsonData[0].data;
        this.ChartProperties = jsonData[0].properties[0];
        // this.ChartProperties.decimalRoundOff = 2;
        // this.ChartProperties.legendPosition = "bottom"
        this.colorCodeList = jsonData[0].ColorCodes;
        this.chartMainData = this.LineChartData;
        this.route.paramMap.subscribe((params) => {
                const userData = history.state.userData;
                this.userselectedchartdata = userData; // Use the userData object as needed
                if (this.userselectedchartdata?.widgetEditSelection) {
                  if (this.userselectedchartdata?.widgetEditSelection?.customizationProperties != "") {
                    this.ChartProperties = JSON.parse(this.userselectedchartdata?.widgetEditSelection?.customizationProperties);
                  }
                }
              });
              
        this.plotLineChart('chart-container' + this.id);
      }, error => {
        console.error('Error fetching data:', error);
      });
    }
    this.initialized = true;
   
  }
  private updateSigSub: Subscription | null = null;

 ngOnDestroy(): void {
    try {
      this.updateSigSub?.unsubscribe();
      if (this.chart) { this.chart.destroy(); this.chart = null; }
        this.subscriptions.unsubscribe();
    } catch (e) {}
    try {
      this.serviceSubscriptions.unsubscribe();
    } catch (e) {}
  }
  Sig_LowerLimt = COMMON_CONSTANTS.SigLowerLimit_95;
  Sig_UpperLimt = COMMON_CONSTANTS.SigUpperLimit_95;
  DefaultConfidenceLevel: any = '';
  private subscriptions: Subscription = new Subscription();
  updatesig() {
    this.updateSigSub?.unsubscribe();
    // Capture whether a higher-level operation (e.g. a filter-change handler)
    // already opened the global loader.  If it did, we must NOT close it when
    // the fast local TrendChartData.json fetch finishes — otherwise the loader
    // disappears while the main getSnapshotOutput API is still in flight.
    const wasAlreadyLoading = this.loader.isCurrentlyLoading;
    this.updateSigSub = this.http.get<any>('assets/Data/TrendChartData.json').subscribe(
        (jsonData) => {
          this.customData.metric_value.sort((a: any, b: any) => (a.selectOrder ?? a.selectorder ?? 0) - (b.selectOrder ?? b.selectorder ?? 0));
          this.data = jsonData[0];
          this.ChartProperties = this.data['properties'][0];
          this.ChartProperties = this.configuredProperties != undefined ? this.configuredProperties : this.ChartProperties;
          this.colorCodeList = this.LineTrendService.color;
          // this.colorCodeList = jsonData[0].ColorCodes;
          this.ChartProperties.datalabelStyle =
            this.significanceValue == 'None' ? 'datalabel' : 'sigChange';
          this.ChartProperties.datalabelStyle = this._configService
            .isIndexSelected
            ? 'index'
            : this.ChartProperties.datalabelStyle;
          this.Sig_LowerLimt =
            this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_95
              ? COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_95
              : this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_90
                ? COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_90
                : this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_98
                  ? COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_98
                  : COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_95;
          this.Sig_UpperLimt =
            this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_95
              ? COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_95
              : this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_90
                ? COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_90
                : this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_98
                  ? COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_98
                  : COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_95;
                  
          // Call preparemainChartData to load the data
          if (!wasAlreadyLoading) { this.loader.showLoader(); }
          this.preparemainChartData(this.customData, this.resolveMetricFilter(this.customData, this.selectedMetric));
          // Group by Series Name; remove any series where every record has Label === null/undefined/'NA'
          const seriesGroups = _.groupBy(this.chartMainData, 'Series Name');
          const validSeriesNames = Object.keys(seriesGroups).filter(seriesName =>
            seriesGroups[seriesName].some((d: any) => d['Label'] !== 'NA' && d['Label'] !== null && d['Label'] !== undefined)
          );
          this.chartMainData = this.chartMainData.filter((d: any) => validSeriesNames.includes(d['Series Name']));
          if (this.chartMainData.length === 0) {
            const containerEl = document.getElementById('chart-container' + this.id);
            if (containerEl) { containerEl.innerHTML = '<div style="display:flex; align-items:center; justify-content:center; height:100%; min-height:100px; font-size: 0.7rem; font-family:KantarBrown-Regular,sans-serif;">Not Applicable</div>'; }
            if (!wasAlreadyLoading) { this.loader.hideLoader(); }
            return;
          }
           this.plotLineChart('chart-container' + this.id);
           if (!wasAlreadyLoading) { this.loader.hideLoader(); }
        },
        (error) => {
          console.error('Error fetching data:', error);
        }
      );
  }

  ngOnChanges(changes: SimpleChanges) {
    // Only re-render when the inputs that actually affect the chart change.
    // Ignoring irrelevant changes (height, sort, WidgetDetails, etc.) prevents
    // spamming updatesig() / TrendChartData.json on every Angular CD cycle.
    const relevantKeys = ['customData', 'brandSelected', 'metricSelected', 'isOutput', 'DataLabelOn', 'Top10Toggle'];
    const hasRelevantChange = relevantKeys.some(k => k in changes);
    if (!hasRelevantChange) return;

    if (changes['customData'] && this.isOutput) {
      const newInput = changes['customData'].currentValue;
      const metric0 = newInput?.metric?.[0];
      // Only update this.customData after ngOnInit has run.
      // ngOnChanges fires before ngOnInit on first render, and ngOnInit
      // expects this.customData to still be the full widget object.
      if (this.initialized && metric0) {
        this.configuredProperties = newInput.customizationProperties
          ? JSON.parse(newInput.customizationProperties)
          : this.configuredProperties;
        this.customData = metric0;
        this.customData.metric_value?.sort((a: any, b: any) => (a.selectOrder ?? a.selectorder ?? 0) - (b.selectOrder ?? b.selectorder ?? 0));
      }
      // Guard: skip render if trend data is not yet populated.
      const hasTrendData = metric0?.metric_value?.some((mv: any) => Array.isArray(mv.data) && mv.data.length > 0);
      if (!hasTrendData) return;
    }

    this.updatesig();
    // Do NOT call ngOnInit() here — updatesig() already handles redraw,
    // and calling ngOnInit() would create duplicate subscriptions.
  }

  private resolveMetricFilter(data: any, candidate: string): string {
    const filter = (candidate || '').trim();
    if (!filter || !this._configService.selectedcompareacrossOption?.includes('Multiple Brands')) {
      return '';
    }
    const options: string[] = (data?.metric_value || []).map((mv: any) => mv.option);
    if (options.includes(candidate)) {
      return candidate;
    }
    const normalizedFilter = filter.includes('|')
      ? filter.substring(filter.indexOf('|') + 1).trim()
      : filter;
    const match = options.find((opt: string) => opt?.trim() === normalizedFilter);
    return match || '';
  }

  private resolveAudienceColChildLabel(colChild: string): string {
    if (!colChild) return '';
    const parts = colChild.split('|').map((p: string) => p.trim());
    if (parts.length === 1) return parts[0];
    const last = parts[parts.length - 1];
    return last.toLowerCase() === 'yes' && parts.length >= 2
      ? parts[parts.length - 2]
      : last;
  }

  private resolveTrendColChild(dataArr: any): string | null {
    if (dataArr.colChild) {
      const parts = dataArr.colChild.split('|');
      return parts.length > 1 ? parts[1].trim() : dataArr.colChild;
    }
    if (this._configService.selectedcompareacrossOption !== 'Multiple Brands') {
      return dataArr.colChild;
    }
    const match = dataArr.rowVariableCode?.match(/_(\d+)$/);
    if (!match) {
      return dataArr.colChild;
    }
    const brandIndex = parseInt(match[1], 10) - 1;
    const sortedBrands = [...(this._configService.brandSortId || [])].sort(
      (a: any, b: any) => a.sortId - b.sortId
    );
    return sortedBrands[brandIndex]?.name ?? null;
  }

  private shouldUseMetricAsSeries(data: any, metricFilter: string): boolean {
    if (this.metricSelected || metricFilter) {
      return false;
    }
    return (data?.metric_value?.length ?? 0) > 1;
  }

  private resolveTrendSeriesName(
    dataArr: any,
    metricGroup: any,
    data: any,
    metricFilter: string
  ): string {
    if (this.shouldUseMetricAsSeries(data, metricFilter)) {
      const option = metricGroup?.option?.trim();
      if (option) {
        return option;
      }
      return this.extractDisplayName(dataArr.rowChild || '');
    }

    const isMulti = this._configService.selectedSnapshotType.toLowerCase().includes('multi');
    if (this.isAudienceSnapshot) {
      if (this._configService.multiCohort) {
        return this.resolveAudienceColChildLabel(dataArr.colChild) || dataArr.rowChild || '';
      }
      // If all audience selections share the same top-level category, strip the common prefix
      const allData: any[] = (data?.metric_value || []).flatMap((mv: any) => mv.data || []);
      const uniqueRowChildren = new Set(allData.map((d: any) => d.rowChild).filter(Boolean));
      // console.log('[AudienceWidget] uniqueRowChildren:', [...uniqueRowChildren], 'colChild:', dataArr.colChild, 'rowChild:', dataArr.rowChild);
      if (uniqueRowChildren.size === 1 && dataArr.colChild) {
        return this.resolveAudienceColChildLabel(dataArr.colChild);
      }
      return dataArr.rowChild || '';
    }
    if (isMulti) {
      return this.resolveTrendColChild(dataArr) || dataArr.rowChild || '';
    }
    if (this._configService.selectedcompareacrossOption?.includes('Multiple Brands')) {
      return this.resolveTrendColChild(dataArr) || dataArr.rowChild || '';
    }
    return dataArr.rowChild || '';
  }

    preparemainChartData(data: any, metricFilter: any = '') {
    this.Top10Toggle=false; // setting this as of now as Top10Toggle is  not implemented
    let i = 0;
    let isTotalBase =  this._configService.finalLeftPanelSubmitObject.isTotalBase;
    this.chartMainData = [];   

    if(this.isAudienceSnapshot && !this._configService.multiCohort){
          this.metricSelected="";
          this.brandSelected="";
    }


    if(!this.isAudienceSnapshot && !this._configService.selectedSnapshotType.toLowerCase().includes("multi")){
      this.metricSelected="";
      this.brandSelected="";
        
    }
      const isMultipleBrands = this._configService.selectedcompareacrossOption?.includes('Multiple Brands');
         const filteredMetricValue = (isMultipleBrands && metricFilter)
      ? data.metric_value.filter((lev2: any) => lev2.option === metricFilter)
      : data.metric_value;
    filteredMetricValue.forEach((lev1: any) => {
      const filteredData = (isMultipleBrands && metricFilter)
  ? lev1.data.filter((d: any) => {
      if (!d.rowChild) return false;
 
      const values = d.rowChild
        .split('|')
        .map((v: string) => v.trim());
 
      return values.includes(metricFilter.trim()) ||
        metricFilter.split('|').map((p: string) => p.trim()).some((part: string) => values.includes(part));
    })
  : lev1.data;
      filteredData.forEach((lev2: any, index: number) => {
        if (
          this.Top10Toggle == false ||
          (this.Top10Toggle == true && index < 10)
        ) {
          if (this.metricSelected != "") {
            const ConditionCheck = lev2.option==null ? lev2.metricName : lev2.option;
            const allOptions = (data?.metric_value || []).map((mv: any) => mv.option?.trim()).filter(Boolean);
            const allSameOption = allOptions.length > 1 && allOptions.every((o: string) => o === allOptions[0]);
            const selectedNormalized = (allSameOption && this.metricSelected?.includes('|')) ? this.metricSelected.split('|').pop()?.trim() : null;
            if (ConditionCheck == this.metricSelected || (selectedNormalized && ConditionCheck?.trim() == selectedNormalized)) {
           let  dataArr=lev2;
              if(dataArr.rowChild.includes(this.metricSelected) || (selectedNormalized && dataArr.rowChild?.includes(selectedNormalized))){
                let d1 = {
                  'Series Name': this.isAudienceSnapshot
                    ? (this._configService.multiCohort
                        ? this.resolveAudienceColChildLabel(dataArr.colChild)
                        : dataArr.rowChild)
                    : (dataArr.colChild.split("|").length>0?dataArr.colChild.split("|")[1]:dataArr.colChild),
                  'Category Name': dataArr.lvl1Child.replace(/^(Month|Year|Quarter)\|/, ''),
                  'Rounded Value':
                    dataArr.data == null
                      ? null
                      : dataArr.CalculationType?.toLowerCase() == 'share' ||
                        dataArr.CalculationType?.toLowerCase() == 'respgrp'
                        ? dataArr.data * 100
                        : dataArr.data,
                  'Value':
                    dataArr.CalculationType?.toLowerCase() == 'share' ||
                      dataArr.CalculationType?.toLowerCase() == 'respgrp'
                      ? dataArr.data * 100
                      : dataArr.data,
                  "ValueForIndex": (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
                  "ActualIndexValue": (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == null) ? null : (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
                  'Label':
                    dataArr.data == null
                      ? 'NA'
                      : dataArr.CalculationType?.toLowerCase() == 'share' ||
                        dataArr.CalculationType?.toLowerCase() == 'respgrp'
                        ? dataArr.data * 100
                        : dataArr.data,
                  'ChangeVs': isTotalBase ? dataArr.changeVsPY_Total :dataArr.changeVsPY_Answer,
                  'Significance': '-1',
                  'Sample size':  this._configService.baseSelected.toLowerCase() == 'total base'
                        ? dataArr.totalUnweightedBase
                        : dataArr.answerUnweightedBase,
                  'Significance2': '1',
                  'Category Image': 'Category_Image_1',
                  'isPercentage':
                    dataArr.CalculationType?.toLowerCase() == 'share' ||
                      dataArr.CalculationType?.toLowerCase() == 'respgrp' ||
                        dataArr.CalculationType?.toLowerCase() == 'meanpercentage'
                      ? true
                      : false,
                  'Sig_LowerLimt': this.Sig_LowerLimt,
                  'Sig_UpperLimt': this.Sig_UpperLimt,
                  "Significance_Value": isTotalBase ? dataArr.Significance_Total : dataArr.Significance_Answer,
                };
                this.chartMainData.push(d1);
              }
              ;
            }
          }
          if(this.brandSelected !=""){
             let  dataArr=lev2;
              if(dataArr.colChild==this.brandSelected){
              let d1 = {
                'Series Name': this.isAudienceSnapshot
                  ? (this._configService.multiCohort
                      ? this.resolveAudienceColChildLabel(dataArr.colChild)
                      : dataArr.rowChild)
                  : dataArr.rowChild ,//.split("|").length>0?dataArr.rowChildsplit("|")[1]:dataArr.rowChild,
                'Category Name': dataArr.lvl1Child.replace(/^(Month|Year|Quarter)\|/, ''),
                'Rounded Value':
                  dataArr.data == null
                    ? null
                    : dataArr.CalculationType?.toLowerCase() == 'share' ||
                      dataArr.CalculationType?.toLowerCase() == 'respgrp'
                      ? dataArr.data * 100
                      : dataArr.data,
                'Value':
                  dataArr.CalculationType?.toLowerCase() == 'share' ||
                    dataArr.CalculationType?.toLowerCase() == 'respgrp'
                    ? dataArr.data * 100
                    : dataArr.data,
                "ValueForIndex": (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
                "ActualIndexValue": (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == null) ? null : (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
                'Label':
                  dataArr.data == null
                    ? 'NA'
                    : dataArr.CalculationType?.toLowerCase() == 'share' ||
                      dataArr.CalculationType?.toLowerCase() == 'respgrp'
                      ? dataArr.data * 100
                      : dataArr.data,
                'ChangeVs': isTotalBase ? dataArr.changeVsPY_Total :dataArr.changeVsPY_Answer,
                'Significance': '-1',
                     'Sample size':  this._configService.baseSelected.toLowerCase() == 'total base'
                        ? dataArr.totalUnweightedBase
                        : dataArr.answerUnweightedBase,
                'Significance2': '1',
                'Category Image': 'Category_Image_1',
                'isPercentage':
                  dataArr.CalculationType?.toLowerCase() == 'share' ||
                    dataArr.CalculationType?.toLowerCase() == 'respgrp' || 
                      dataArr.CalculationType?.toLowerCase() == 'meanpercentage'
                    ? true
                    : false,
                'Sig_LowerLimt': this.Sig_LowerLimt,
                'Sig_UpperLimt': this.Sig_UpperLimt,
                "Significance_Value": isTotalBase ? dataArr.Significance_Total : dataArr.Significance_Answer,
              };
              this.chartMainData.push(d1);
            }
            ;
          }
          if(this.brandSelected=="" && this.metricSelected=="") {
             let  dataArr=lev2;
              let d1 = {
                'Series Name': this.resolveTrendSeriesName(dataArr, lev1, data, metricFilter),
                'Category Name': dataArr?.lvl1Child?.replace(/^(Month|Year|Quarter)\|/, ''),
                'Rounded Value':
                  dataArr.data == null
                    ? null
                    : dataArr.CalculationType?.toLowerCase() == 'share' ||
                      dataArr.CalculationType?.toLowerCase() == 'respgrp'
                      ? dataArr.data * 100
                      : dataArr.data,
                'Value':
                  dataArr.CalculationType?.toLowerCase() == 'share' ||
                    dataArr.CalculationType?.toLowerCase() == 'respgrp'
                    ? dataArr.data * 100
                    : dataArr.data,
                "ValueForIndex": (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
                "ActualIndexValue": (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == null) ? null : (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
                'Label':
                  dataArr.data == null
                    ? 'NA'
                    : dataArr.CalculationType?.toLowerCase() == 'share' ||
                      dataArr.CalculationType?.toLowerCase() == 'respgrp'
                      ? dataArr.data * 100
                      : dataArr.data,
                'ChangeVs': isTotalBase ? dataArr.changeVsPY_Total :dataArr.changeVsPY_Answer,
                'Significance': '-1',
                'Sample size':  this._configService.baseSelected.toLowerCase() == 'total base'
                        ? dataArr.totalUnweightedBase
                        : dataArr.answerUnweightedBase,
                'Significance2': '1',
                'Category Image': 'Category_Image_1',
                'isPercentage':
                  dataArr.CalculationType?.toLowerCase() == 'share' ||
                    dataArr.CalculationType?.toLowerCase() == 'respgrp' ||
                    dataArr.CalculationType?.toLowerCase() == 'meanpercentage'
                    ? true
                    : false,
                'Sig_LowerLimt': this.Sig_LowerLimt,
                'Sig_UpperLimt': this.Sig_UpperLimt,
                "Significance_Value": isTotalBase ? dataArr.Significance_Total : dataArr.Significance_Answer,
              };
              this.chartMainData.push(d1);
            ;
          }
        }
      });
    })
    // this.chartMainData=this.chartMainData.slice(0,1);
  }
 
 
  commonfunc(event: any, customization: string, options: any) {
    this.event = event;
    this.ChartProperties = this.LineTrendService.commonFunc(customization, event, '', '', this.ChartProperties)
    this.plotLineChart('chart-container' + this.id);
  }

  plotyaxis() {
    if (
      this.ChartProperties.stacking == 1 ||
      this.ChartProperties.stacking == 2
    ) {
      return {
        title: {
          text: '',
          style: {
            color: this.ChartProperties.darkTheme ? 'white' : 'Black',
          },
        },

        // gridLineWidth: this.ChartProperties.gridlines,
        gridLineWidth: this.ChartProperties.yaxisgridlines ? 1 : 0,
gridLineColor: '#D9D9D9',
        labels: {
          rotation: this.LineTrendService.axisLabelOrientation(
            this.ChartProperties.yaxisLabelOrientation
          ),
          format:
            this.ChartProperties.datalabelFormat == 'number'
              ? '{value}'
              : '{value}%',
          style: {
            color: this.ChartProperties.darkTheme ? 'white' : 'Black',
          },
        },
      };
    } else {
      // return {
      //   title: {
      //     text: '',
      //     style: {
      //       color: this.ChartProperties.darkTheme ? 'white' : 'Black',
      //     },
      //   },
      //   min: this.showLowSample ? 0 : this.chartMinAxis,
      //   // max: this.chartMaxAxis > 100 ? 100 : this.chartMaxAxis,
      //   max: this.chartMaxAxis,
      //   gridLineWidth: this.ChartProperties.gridlines,
      //   labels: {
      //     rotation: this.LineTrendService.axisLabelOrientation(
      //       this.ChartProperties.yaxisLabelOrientation
      //     ),
      //     format:
      //       this.ChartProperties.datalabelFormat == 'number'
      //         ? '{value}'
      //         : '{value}%',
      //     style: {
      //       color: this.ChartProperties.darkTheme ? 'white' : 'Black',
      //     },
      //   },
      // };
      return {
        title: {
          text: '',
          style: {
            color: this.ChartProperties.darkTheme ? 'white' : 'Black',
          },
        },
        min: this.showLowSample ? 0 : this.chartMinAxis,
        max: this.chartMaxAxis,
        tickInterval: 10, // Set the tick interval to always be 10
        // gridLineWidth: this.ChartProperties.gridlines,
        gridLineWidth: this.ChartProperties.yaxisgridlines ? 1 : 0,
gridLineColor: '#D9D9D9',
        labels: {
          rotation: this.LineTrendService.axisLabelOrientation(
            this.ChartProperties.yaxisLabelOrientation
          ),
          format:
            this.ChartProperties.datalabelFormat == 'number'
              ? '{value}'
              : '{value}%',
          style: {
            color: this.ChartProperties.darkTheme ? 'white' : 'Black',
          },
        },
      }

    }
  }

  plotLineChart(containerId: any) {
    if (this.isOutput) {
      localStorage.setItem('properties', JSON.stringify(this.ChartProperties));
     
      this.prepareSeriesDataForChart();
      let properties = this.ChartProperties;
      let samplesizeConstantValue = this._configService.ISthreshold;
      //const updatedCategoryNames = this.LineTrendService.updatedCategories.map(category => category.image);
      //let updatedCategories = this.LineTrendService.updatedCategories;
      let ispercentage = false;
      let that = this;
      let colors = this.colorCodeList;
      if (this.ChartProperties.datalabelFormat === 'percentage') {
        ispercentage = true;
      }

      if (
        this.ChartProperties.stacking == 1 ||
        this.ChartProperties.stacking == 2
      ) {
        this.seriesData.reverse();
      }

      let configService = this._configService;

      const containerEl = document.getElementById(containerId);
      if (!containerEl) { return; }
      if (this.chart) {
  this.chart.destroy();
}
      this.chart = new Highcharts.Chart(containerEl, {
        chart: {
          type: 'line',
          marginLeft: 50, // Increase left margin
          marginRight: 50,
          animation: false,
          //height: '38%',
          width: null,
          backgroundColor: this.ChartProperties.darkTheme ? 'Black' : 'white',
          style: {
            color: this.ChartProperties.darkTheme ? 'white' : 'Black',
            fontFamily: 'KantarBrown-Regular',
            fontSize: '0.7rem',
             zIndex: 1,
          overflow: 'visible',
          },
          zoomType: 'xy'
        },
        title: {
          text: '',
          style: {
            color: this.ChartProperties.darkTheme ? 'white' : 'Black',
          },
          align: this.ChartProperties.chartTitlePosition,
        },
        credits: {
          enabled: false,
        },
        yAxis: this.plotyaxis(),
        xAxis: {
          title: {
            text: '',
            style: {
              fontSize: '12px',
              color: '#E8E8E8',
            },
          },
          // min: 0,
          // gridLineWidth: this.ChartProperties.gridlines,
        gridLineWidth: this.ChartProperties.xaxisgridlines ? 1 : 0,
gridLineColor: '#D9D9D9',
          categories: properties.axisImage
            ? this.updateCategoryName
            : this.categoriesList,
          labels: {
            rotation: this.LineTrendService.axisLabelOrientation(
              this.ChartProperties.axisLabelOrientation
            ),
            style: {
              color: this.ChartProperties.darkTheme ? 'white' : 'Black',
            },
            useHTML: true,
            formatter: function (
              this: Highcharts.AxisLabelsFormatterContextObject
            ) {
              if (properties.axisImage) {
                var index = this.axis.categories.indexOf(String(this.value));
                var category = that.updateCategoryName[index];

                if (category) {
                  return (
                    '<span style="display: inline-block; width: 2em; height: 2em; background: url(../../../../../../assets/Images/LineOrTrendChart/' +
                    category +
                    '.png) no-repeat center center; background-size: cover;"></span>'
                  );
                } else {
                  return '<span>No Image</span>';
                }
              } else {
                return String(this.value);
              }
            },
          },
        },

        tooltip: {
          enabled: true,
          borderWidth: 0,
          useHTML: true,
          shape: properties.toolTipStyle == 'style1' ? 'square' : 'callout',
          shadow: false,
          backgroundColor: 'rgba(0,0,0,0)',
outside: true,
  style: {
            fontSize: '0.5em', // Reduce tooltip font size
            padding: '2px'
          },
          formatter: function (this: any) {
            const pointWithMetric = (
              this as Highcharts.TooltipFormatterContextObject
            ).point as {
              name?: any;
              parent?: any;
              color?: any;
              y?: number;
              y1?: number;
              cov?: string;
              significance?: string;
              samplesize?: number;
              significance2?: any;
              tooltip?: any;
              isPercentage?: any;
              Sig_LowerLimt?: any;
              Sig_UpperLimt?: any;
              Significance_Value?: any;
              indexValue?: any
            };

            let roundedValue = this.series.userOptions.data1[this.point.x]['Rounded Value'];
            properties.dataLabelFormat = pointWithMetric.isPercentage;
            if (roundedValue == null && properties.datalabelStyle == 'datalabel') return 'NA';
              pointWithMetric.tooltip = 'NA';
            if (properties.datalabelStyle === 'index') {

              let finalText: any = roundedValue == null
                ? 'NA'
                : configService.CheckLSorIScondition(
                    configService.userRole,
                    this.y + (this.series.userOptions.data1[this.point.x]['isPercentage'] && '%'),
                    this.series.userOptions.data1[this.point.x]['Sample size']
                  );
              // pointWithMetric.tooltip = finalText;


              let text2 = pointWithMetric.y1 != null ? pointWithMetric.indexValue : 'NA';
              //text = configService.CheckLSorIScondition(configService.userRole, text, Number(pointWithMetric.samplesize));
              let color = configService.CheckIndexColoring(String(text2));
              text2 = `<span style="color: ${color} ;">${text2}</span>`;
              pointWithMetric.tooltip = finalText + "(" + text2 + ")";
              // return (
              //   '<span style="color:' + 'black' + ';">' + text + '</span>'
              // );
            }
            else if (properties.datalabelStyle === 'sigChange') {
              let changeVal = pointWithMetric.isPercentage
                ? Number(pointWithMetric.cov) * 100
                : Number(pointWithMetric.cov);
              if (
                pointWithMetric.cov == null ||
                pointWithMetric.cov == 'NA'
              ) {
                let text =
                  pointWithMetric.y1 != null
                    ? pointWithMetric.y +
                    (properties.dataLabelFormat ? '%' : '') +
                    ' ' +
                    `<span span style="font-size: 80%;color:black;">(${'NA'})</span>`
                    : 'NA';
                pointWithMetric.tooltip = text;
                // return (
                //   '<span style:"color:' + 'black' + ';">' + text + '</span>'
                // );
              } else {
                let val = pointWithMetric.y != null
                  ? pointWithMetric.y +
                  (properties.dataLabelFormat ? '%' : '') : 'NA';
                val = configService.CheckLSorIScondition(
                  configService.userRole,
                  val,
                  pointWithMetric.samplesize ? pointWithMetric.samplesize : 0
                );

                if (val == "I/S") {
                  pointWithMetric.tooltip = val;
                } else {

                  let sigClass =
                    pointWithMetric.Significance_Value < pointWithMetric.Sig_LowerLimt
                      ? 'red'
                      : pointWithMetric.Significance_Value > pointWithMetric.Sig_UpperLimt
                        ? 'green'
                        : 'black';
                  let text =
                    pointWithMetric.y1 != null
                      ? pointWithMetric.y +
                      (properties.dataLabelFormat ? '%' : '') +
                      ' ' +
                      `<span style="font-size: 80%;  color: ${sigClass};">(` +
                      `${pointWithMetric.cov != null
                        ? parseFloat(Number(changeVal).toFixed(1)) + (pointWithMetric.isPercentage
                          ? '%' : '')
                        : 'NA'
                      })</span>`
                      : 'NA';
                  pointWithMetric.tooltip = text;
                }
                // return (
                //   '<span style:"color:' + 'black' + ';">' + text + '</span>'
                // );
              }
            }
            else {
              let finalText =
                this.y +
                (this.series.userOptions.data1[this.point.x]['isPercentage'] &&
                  '%');
              finalText = configService.CheckLSorIScondition(
                configService.userRole,
                finalText,
                this.series.userOptions.data1[this.point.x]['Sample size']
              );
              pointWithMetric.tooltip = finalText;
            }


            if (this.series.name === 'Marker1') return false;
            let isDefaultTooltip = properties.toolTipStyle;
            const text = properties.showDataLabel
              ? this.series.userOptions.tooltip[this.point.x]
              : this.y;
            const dotColor = this.series.color;
            const backgroundcolor = properties.darkTheme ? '#b3b3b3' : '#f5f5f5';
            const backgroundcolor2 = properties.darkTheme ? '#dddddd' : 'white';
            if (isDefaultTooltip == 'style1') {
              const commonContent =
                `<div style="width:120%;border-left: 5px solid ${dotColor}; border-bottom: 5px solid ${dotColor}; z-index: 100; padding: 3%; border-radius: 5px; margin: 0; background-color: ${backgroundcolor2};">` +
                `<span style="display: block; text-align: center; color: ${dotColor}; font-weight: bold; font-size: 1rem;">Tooltip Title</span>` +
                `<span><strong>Series Name:</strong></span> ${this.series.userOptions.name}<br>` +
                `<span><strong>Category Name:</strong></span> ${this.series.userOptions.data1[this.point.x]['Category Name']
                }<br>` +
                `<span><strong>Value:</strong></span> ${pointWithMetric.tooltip}`;
              return commonContent + '</div>';
            } else {
              // Get the series color
              const content =
                `<div style="background-color: white; padding: 3%; align-items: center; border: 1px solid ${dotColor};min-width:10px;max-width:100em;width:120%;">` +
                `<div style="display:flex"><div style="width: 1em; height: 1em; background-color: ${dotColor}; border-radius: 50%;"> </div>` +
                `<div style="width:90%; padding-left:5%;"> ${this.series.name} </div></div>` +
                `<div style="display: block; margin-top: 1%; margin-left:12%;"><strong>Value:</strong> ${pointWithMetric.tooltip}</div>`;
              return content + '</div>';
            }
          },
        } as any,
        legend: this.LineTrendService.customizeLegend1(this.ChartProperties.showLegend, properties.legendPosition, this.ChartProperties.darkTheme, this.ChartProperties.stacking),
        // legend: {
        //   enabled: true,
        //   events: {
        //     itemHover: function (event: any) {
        //       // Display tooltip when hovering over legend item
        //       const point = event.target;
        //       const tooltip = document.createElement('div');
        //       tooltip.className = 'custom-tooltip';
        //       tooltip.style.position = 'absolute';
        //       tooltip.style.backgroundColor = 'rgba(0, 0, 0, 0.7)';
        //       tooltip.style.color = 'white';
        //       tooltip.style.padding = '5px';
        //       tooltip.style.borderRadius = '3px';
        //       tooltip.style.pointerEvents = 'none';
        //       tooltip.innerText = point.name;
        //       document.body.appendChild(tooltip);

        //       // Position tooltip
        //       document.addEventListener('mousemove', function (e) {
        //         tooltip.style.left = e.pageX + 10 + 'px';
        //         tooltip.style.top = e.pageY + 10 + 'px';
        //       });
        //     },
        //     itemMouseOut: function (event: any) {
        //       // Remove tooltip when mouse leaves legend item
        //       const tooltip = document.querySelector('.custom-tooltip');
        //       if (tooltip) {
        //         tooltip.remove();
        //       }
        //     },
        //   },
        //   // reversed: (this.ChartProperties.stacking == 1 || this.ChartProperties.stacking == 2) ? true : false,
        //   align: 'right',
        //   verticalAlign: 'middle',
        //   layout: 'vertical',
        //   // itemStyle: {
        //   //   color: "Black",
        //   //   fontWeight: "normal",
        //   //   fontSize: "0.8em",
        //   //   fontFamily: "Kantar Regular"
        //   // },
        //   width: 300,
        //   itemStyle: {
        //     fontWeight: 'normal',
        //     fontSize: this.height != '100%' ? '0.8em' : '1em',
        //     cursor: 'pointer',
        //   },
        //   useHTML: true,
        //   // symbolWidth: -1,
        //   // symbolHeight: -1,
        //   labelFormatter: function (): any {
        //     let point = this as any;
        //     // let textcolor = chartproperties.darkTheme ? 'white' : 'black';
        //     if (point.color != '#eeebed' && point.color != '#7f7f7f') {
        //       return (
        //         '<div style="display:flex;align-items:center;font-size:0.8em;" title="' +
        //         point.name +
        //         '">' +
        //         '<div style="display:flex;width:10px;height:10px;background-color:' +
        //         point.legendkeycolor +
        //         ';border-radius:50%"></div>' +
        //         '<div style="z-index: 10000; height: 20px; padding-left: 10px; padding-top: 1%; color: black; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; flex: 1; font: KantarBrown-Regular; cursor: pointer;" title="' +
        //         point.name +
        //         '">' +
        //         '   ' +
        //         point.name +
        //         '   ' +
        //         '</div>' +
        //         '</div>'
        //       );
        //     }
        //   },
        // },

        plotOptions: {
          series: {
            animation: false,
          },
          line: {
            stacking:
              this.ChartProperties.stacking == 0
                ? ''
                : this.ChartProperties.stacking == 1
                  ? 'normal'
                  : 'percent',
            lineWidth: properties.lineWidth,
            dashStyle: properties.Linestyle,
            fillOpacity: 0.4,
            marker: {
              enabled: true,
              symbol: properties.markerStyle,
              radius: 4,
              lineWidth: properties.markerLineWidth,
            },
            dataLabels: {
              enabled: properties.showDataLabel,
              allowOverlap: false,
              overflow: 'justify',
              crop: false,
              align:
                properties.dataLabelPosition == 'left'
                  ? 'right'
                  : properties.dataLabelPosition == 'right'
                    ? 'left'
                    : 'center',
              rotation: properties.datalabelOrientation,
              backgroundColor: 'transparent',
              color: properties.darkTheme
                ? properties.dataLabelColor === 'default'
                  ? 'white'
                  : properties.dataLabelColor
                : properties.dataLabelColor === 'default'
                  ? 'black'
                  : properties.dataLabelColor,
              style: {
                fontSize: properties.dataLabelSize,
                textOutline: 'none',
                fontWeight: 'normal',
              },
                formatter: function (this: any) {
                             const pointWithMetric = (
                               this as Highcharts.TooltipFormatterContextObject
                             ).point as {
                               name?: any;
                               parent?: any;
                               color?: any;
                               y?: number;
                               y1?: number;
                               cov?: string;
                               significance?: string;
                               samplesize?: number;
                               significance2?: any;
                               tooltip?: any;
                               isPercentage?: any;
                               Sig_LowerLimt?: any;
                               Sig_UpperLimt?: any;
                               Significance_Value?: any;
                               indexValue?: any
                             };
                             const upwardTriangle = '&#9650';
                             const downwardTriangle = '\u25BC';
                             let roundedValue =
                               this.series.userOptions.data1[this.point.x]['Rounded Value'];
                             properties.dataLabelFormat = pointWithMetric.isPercentage;
                             if (roundedValue == null && properties.datalabelStyle == 'datalabel') return 'NA';
                             if (properties.datalabelStyle === 'index') {
             
                               let finalText: any = roundedValue == null
                                ? 'NA'
                                : configService.CheckLSorIScondition(
                                    configService.userRole,
                                    this.y + (this.series.userOptions.data1[this.point.x]['isPercentage'] && '%'),
                                    this.series.userOptions.data1[this.point.x]['Sample size']
                                  );
                               pointWithMetric.tooltip = finalText;
                   
                   
                               let text2 = pointWithMetric.y1 != null ? pointWithMetric.indexValue : 'NA';
                               //text = configService.CheckLSorIScondition(configService.userRole, text, Number(pointWithMetric.samplesize));
                               let color = configService.CheckIndexColoring(String(text2));
                               text2 = `<span style="color: ${color} ;">${text2}</span>`;
                               pointWithMetric.tooltip =finalText+ "("+text2+")";
                               return (
                                 '<span style="color:' + 'black' + ';">' + finalText+ "("+text2+")" + '</span>'
                               );
                             }
               
                             if (properties.datalabelStyle === 'sigChange') {
                               let changeVal = pointWithMetric.isPercentage
                                 ? Number(pointWithMetric.cov) * 100
                                 : Number(pointWithMetric.cov);
                               if (
                                 pointWithMetric.cov == null ||
                                 pointWithMetric.cov == 'NA'
                               ) {
                                 let text =
                                   pointWithMetric.y1 != null
                                     ? pointWithMetric.y +
                                     (properties.dataLabelFormat ? '%' : '') +
                                     ' ' +
                                     `<span span style="font-size: 80%;color:black;">(${'NA'})</span>`
                                     : 'NA';
                                 pointWithMetric.tooltip = text;
                                 return (
                                   '<span style:"color:' + 'black' + ';">' + text + '</span>'
                                 );
                               } else {
             
                                 let val = pointWithMetric.y != null
                                   ? pointWithMetric.y +
                                   (properties.dataLabelFormat ? '%' : '') : 'NA';
                                 // val = configService.CheckLSorIScondition(
                                 //   configService.userRole,
                                 //   val,
                                 //   pointWithMetric.samplesize ? pointWithMetric.samplesize : 0
                                 // );
             
                                 if (val == "I/S") {
                                   return (
                                     '<span style:"color:' + 'black' + ';">' + val + '</span>'
                                   );
                                 }
             
                                 let sigClass =
                                    pointWithMetric.Significance_Value < pointWithMetric.Sig_LowerLimt
                                     ? 'red'
                                     : pointWithMetric.Significance_Value > pointWithMetric.Sig_UpperLimt
                                       ? 'green'
                                       : 'black';
             
             
                                 let text =
                                   pointWithMetric.y1 != null
                                     ? pointWithMetric.y +
                                     (properties.dataLabelFormat ? '%' : '') +
                                     ' ' +
                                     `<span style="font-size: 80%;  color: ${sigClass};">(` +
                                     `${pointWithMetric.cov != null
                                       ? parseFloat(Number(changeVal).toFixed(1)) + (pointWithMetric.isPercentage
                                         ? '%' : '')
                                       : 'NA'
                                     })</span>`
                                     : 'NA';
                                 pointWithMetric.tooltip = text;
                                 return (
                                   '<span style:"color:' + 'black' + ';">' + text + '</span>'
                                 );
                               }
                             }
                             let finalText =
                               this.y +
                               (this.series.userOptions.data1[this.point.x]['isPercentage'] &&
                                 '%');
                             finalText = configService.CheckLSorIScondition(
                               configService.userRole,
                               finalText,
                               this.series.userOptions.data1[this.point.x]['Sample size']
                             );
                             pointWithMetric.tooltip = finalText;
                             this.series.userOptions.tooltip[this.point.x] = finalText;
                             return finalText;
                             // if (properties.datalabelStyle == "significance + changeVs") {
                             //   text = this.y + (this.series.userOptions.data1[this.point.x]["isPercentage"] && '%');
                             //   changeText = this.series.userOptions.data1[this.point.x]["ChangeVs"];
                             //   let sig = this.series.userOptions.data1[this.point.x]["Significance"];
                             //   let s = sig > 0 ? upwardTriangle : (sig < 0 ? downwardTriangle : '');
                             //   let sigcolor = sig > 0 ? 'green' : (sig < 0 ? 'red' : '');
                             //   let finalText = '<span>' + text +
                             //     (changeText ? '&nbsp;<span>' +
                             //       '' + `<span style="font-size: 80%; color:${properties.darkTheme ? "white" : "black"}">(` + changeText + ')</span>' + '&nbsp;' +
                             //       '<span style="color:' + sigcolor + ';">' + s + '</span>' : '') +
                             //     '</span>';
                             //   this.series.userOptions.tooltip[this.point.x] = finalText;
             
                             //   return (
                             //     finalText
                             //   );
                             // }
             
                             // if (properties.datalabelStyle == "change") {
                             //   text = this.y + (this.series.userOptions.data1[this.point.x]["isPercentage"] && '%')
                             //   //text = this.y != 0 ? this.y + ( ispercentage && '%' ) : 'NA';
                             //   changeText = this.series.userOptions.data1[this.point.x]["ChangeVs"];
                             //   let finalText = '<span>' + text + '' +
                             //     (changeText ? `<span style="font-size: 80%; color:${properties.darkTheme ? "white" : "black"}">(` + changeText + ')</span>' : '') +
                             //     '</span>'
                             //   this.series.userOptions.tooltip[this.point.x] = finalText;
                             //   return (
                             //     finalText
                             //   );
                             // }
             
                             // if (properties.datalabelStyle == "significance") {
                             //   text = this.y + (this.series.userOptions.data1[this.point.x]["isPercentage"] && '%');
                             //   // text = this.y != 0 ? this.y + ( ispercentage && '%' ) : 'NA';
                             //   let sig = this.series.userOptions.data1[this.point.x]["Significance"];
                             //   let s = sig > 0 ? upwardTriangle : (sig < 0 ? downwardTriangle : '');
                             //   let sigcolor = sig > 0 ? 'green' : (sig < 0 ? 'red' : '');
                             //   let finalText = '<span >' + text + '&nbsp<span style="color:' + sigcolor + ';">' + s + '</span></span>';
                             //   this.series.userOptions.tooltip[this.point.x] = finalText;
                             //   return (
                             //     finalText
                             //   );
                             // }
             
                             // if (properties.datalabelStyle == "significance2") {
                             //   text = this.y + (this.series.userOptions.data1[this.point.x]["isPercentage"] && '%');
                             //   changeText = this.series.userOptions.data1[this.point.x]["ChangeVs"];
                             //   let sig = this.series.userOptions.data1[this.point.x]["Significance"];
                             //   let sig1 = this.series.userOptions.data1[this.point.x]["Significance2"];
                             //   let s = sig > 0 ? upwardTriangle : (sig < 0 ? downwardTriangle : '');
                             //   let changeColor = sig1 < 0 ? 'red' : (sig1 > 0 ? 'green' : properties.darkTheme ? "white" : "Black");
                             //   let sigcolor = sig > 0 ? 'green' : (sig < 0 ? 'red' : '');
                             //   let finalText = '<span>' + text +
                             //     (changeText ? '&nbsp<span style="color:' + ';"> ' +
                             //       '<span style="font-size: 80%; color:' + changeColor + ';">(' + changeText + ')</span>&nbsp' +
                             //       '<span style="color:' + sigcolor + ';">' + s + '</span>' : '') +
                             //     '</span>';
                             //   this.series.userOptions.tooltip[this.point.x] = finalText;
                             //   return (
                             //     finalText
                             //   );
                             // }
             
                             // if (properties.datalabelStyle == "ls") {
                             //   text = this.series.userOptions.data1[this.point.x]["Sample size"] >= samplesizeConstantValue ? this.y + (this.series.userOptions.data1[this.point.x]["isPercentage"] && '%') : 'LS';
                             //   let finalText = '<b>' +
                             //     text +
                             //     '</b> ' +
                             //     '<span style="opacity: 0.5"></span>';
                             //   this.series.userOptions.tooltip[this.point.x] = finalText;
                             //   return (
                             //     finalText
                             //   );
                             // }
                           },
            },
          },
        },
        series: this.seriesData,
      } as any);

      var chart = this.chart;
      var legendWidth = chart.legend.legendWidth;
      // Adjust margins based on the legend width

      if (
        this.ChartProperties.legendPosition == 'left' &&
        this.ChartProperties.showLegend
      ) {
        this.chart.update(
          {
            chart: {
              marginLeft: legendWidth + 40, // Add some extra space
              marginRight: 30,
              style: {
              color: this.ChartProperties.darkTheme ? 'white' : 'Black',
              fontFamily: 'KantarBrown-Regular',
              fontSize: '0.7rem'
          },
            },
          },
          false
        );
      }

      if (
        this.ChartProperties.legendPosition == 'right' &&
        this.ChartProperties.showLegend
      ) {
        this.chart.update(
          {
            chart: {
              marginLeft: 60, // Add some extra space
              marginRight: legendWidth + 25,
            },
          },
          false
        );
      }

    }
    else {
      localStorage.setItem("properties", JSON.stringify(this.ChartProperties));
      this.prepareSeriesDataForChart();
      let properties = this.ChartProperties;
      let samplesizeConstantValue = this.samplesizeConstantValue;
      //const updatedCategoryNames = this.LineTrendService.updatedCategories.map(category => category.image);
      //let updatedCategories = this.LineTrendService.updatedCategories;
      let ispercentage = false;
      let that = this;
      let colors = this.colorCodeList;
      if (this.ChartProperties.datalabelFormat === "percentage") {
        ispercentage = true;
      }

      if (this.ChartProperties.stacking == 1 || this.ChartProperties.stacking == 2) {
        this.seriesData.reverse();
      }
      const containerEl = document.getElementById(containerId);
      if (!containerEl) { return; }
      if (this.chart) {
  this.chart.destroy();
}
      this.chart = new Highcharts.Chart(containerEl, {
        chart: {
          type: 'line',
          marginLeft: 50,   // Increase left margin
          marginRight: 50,
          
          backgroundColor: this.ChartProperties.darkTheme ? "Black" : "white",
          zooming: {
            type: 'xy'
          },
          style: {
            color: this.ChartProperties.darkTheme ? "white" : "Black",
            fontFamily: 'KantarBrown-Regular',
            fontSize: '0.8rem',
            zIndex: 1,
          overflow: 'visible',
          },

        },
        title: {
          text: "",
          style: {
            color: this.ChartProperties.darkTheme ? "white" : "Black",
            fontFamily: 'KantarBrown-Regular'
          },
          align: this.ChartProperties.chartTitlePosition,
        },
        credits: {
          enabled: false
        },
        yAxis: this.plotyaxis(),
        xAxis: {
          title: {
            text: '',
            style: {
              fontSize: '12px',
              color: '#E8E8E8'
            }
          },
          // min: 0,
          gridLineWidth: this.ChartProperties.xaxisgridlines ? 1 : 0,
gridLineColor: '#D9D9D9',
          categories: properties.axisImage ? this.updateCategoryName : this.categoriesList,
          labels: {
            rotation: this.LineTrendService.axisLabelOrientation(this.ChartProperties.axisLabelOrientation),
            style: {
              color: this.ChartProperties.darkTheme ? "white" : "Black"
            },
            useHTML: true,
            formatter: function (this: Highcharts.AxisLabelsFormatterContextObject) {
              if (properties.axisImage) {
                var index = this.axis.categories.indexOf(String(this.value));
                var category = that.updateCategoryName[index];

                if (category) {
                  return '<span style="display: inline-block; width: 2em; height: 2em; background: url(../../../../../../assets/Images/LineOrTrendChart/' + category + '.png) no-repeat center center; background-size: cover;"></span>';
                } else {
                  return '<span>No Image</span>';
                }
              } else {
                return String(this.value);
              }
            },
          }
        },

        tooltip: {
          enabled: true,
          borderWidth: 0,
          useHTML: true,
          shape: properties.toolTipStyle == "style1" ? 'square' : 'callout',
          shadow: false,
          backgroundColor: 'rgba(0,0,0,0)',

          formatter: function () {
            if (this.series.name === 'Marker1') return false;
            let isDefaultTooltip = properties.toolTipStyle;
            const text = properties.showDataLabel ? this.series.userOptions.tooltip[this.point.x] : this.y;
            const dotColor = this.series.color;
            const backgroundcolor = properties.darkTheme ? '#b3b3b3' : '#f5f5f5';
            const backgroundcolor2 = properties.darkTheme ? '#dddddd' : 'white';
            if (isDefaultTooltip == "style1") {
              const commonContent =
                `<div style="width:120%;border-left: 5px solid ${dotColor}; border-bottom: 5px solid ${dotColor}; z-index: 100; padding: 3%; border-radius: 5px; margin: 0; background-color: ${backgroundcolor2};">` +
                `<span style="display: block; text-align: center; color: ${dotColor}; font-weight: bold; font-size: 1rem;">Tooltip Title</span>` +
                `<span><strong>Series Name:</strong></span> ${this.series.userOptions.name}<br>` +
                `<span><strong>Category Name:</strong></span> ${this.series.userOptions.data1[this.point.x]["Category Name"]}<br>` +
                `<span><strong>Value:</strong></span> ${text}`;
              return commonContent + '</div>';
            }
            else {

              // Get the series color
              const content =
                `<div style="background-color: ${backgroundcolor}; padding: 10%; align-items: center; border: 1px solid ${dotColor}; width:120%">` +
                `<div style="width: 1em; height: 1em; background-color: ${dotColor}; border-radius: 50%; margin-right: 5%;"> </div>` +
                ` ${this.series.name}` +
                `<div style="display: block; margin-top: 1%;"><strong>Value:</strong> ${text}</div>`;
              return content + '</div>';
            }
          },
        } as any,
        legend: this.LineTrendService.customizeLegend1(properties.showLegend, properties.legendPosition, this.ChartProperties.darkTheme, this.ChartProperties.stacking),
        plotOptions: {
          series: {
            animation: false
          },
          line: {
            stacking: this.ChartProperties.stacking == 0 ? "" : (this.ChartProperties.stacking == 1 ? "normal" : "percent"),
            lineWidth: properties.lineWidth,
            dashStyle: properties.Linestyle,
            fillOpacity: 0.4,
            marker: {
              enabled: true,
              symbol: properties.markerStyle,
              radius: 4,
              lineWidth: properties.markerLineWidth,
            },
            dataLabels: {
              enabled: properties.showDataLabel,
              allowOverlap: false,
              overflow: 'justify',
              crop: false,
              align: properties.dataLabelPositionPPT == "left" ? "right" : (properties.dataLabelPositionPPT == "right" ? "left" : "center"),
              rotation: properties.datalabelOrientation,
              backgroundColor: 'transparent',
              color: properties.darkTheme ? (properties.dataLabelColor === 'default' ? 'white' : properties.dataLabelColor)
                : (properties.dataLabelColor === 'default' ? 'black' : properties.dataLabelColor),
              style: {
                fontSize: properties.dataLabelSize,
                textOutline: 'none',
                fontWeight: "normal",
              },
              formatter: function (this: any) {
                const upwardTriangle = '&#9650';
                const downwardTriangle = '\u25BC';
                let text;
                let changeText;
                let roundedValue = this.series.userOptions.data1[this.point.x]["Rounded Value"];
                if (roundedValue == null) {
                  this.series.userOptions.tooltip[this.point.x] = "NA";
                  return "NA";
                }

                if (properties.datalabelStyle == "sigchan") {
                  text = this.y + (ispercentage && '%')
                  //text = this.y != 0 ? this.y + ( ispercentage && '%' ) : 'NA';
                  changeText = this.series.userOptions.data1[this.point.x]["ChangeVs"];
                  let finalText = '<span>' + text + '' +
                    (changeText ? `<span style="font-size: 80%; color:${properties.darkTheme ? "white" : "black"}">(` + changeText + ')</span>' : '') +
                    '</span>'
                  this.series.userOptions.tooltip[this.point.x] = finalText;
                  return (
                    finalText
                  );
                }

                if (properties.datalabelStyle == "change") {
                  text = this.y + (ispercentage && '%')
                  //text = this.y != 0 ? this.y + ( ispercentage && '%' ) : 'NA';
                  changeText = this.series.userOptions.data1[this.point.x]["ChangeVs"];
                  let finalText = '<span>' + text + '' +
                    (changeText ? `<span style="font-size: 80%; color:${properties.darkTheme ? "white" : "black"}">(` + changeText + ')</span>' : '') +
                    '</span>'
                  this.series.userOptions.tooltip[this.point.x] = finalText;
                  return (
                    finalText
                  );
                }

                if (properties.datalabelStyle == "significance") {
                  text = this.y + (ispercentage && '%');
                  // text = this.y != 0 ? this.y + ( ispercentage && '%' ) : 'NA';
                  let sig = this.series.userOptions.data1[this.point.x]["Significance"];
                  let s = sig > 0 ? upwardTriangle : (sig < 0 ? downwardTriangle : '');
                  let sigcolor = sig > 0 ? 'green' : (sig < 0 ? 'red' : '');
                  let finalText = '<span >' + text + '&nbsp<span style="color:' + sigcolor + ';">' + s + '</span></span>';
                  this.series.userOptions.tooltip[this.point.x] = finalText;
                  return (
                    finalText
                  );
                }

                if (properties.datalabelStyle == "significance2") {
                  text = this.y + (ispercentage && '%');
                  changeText = this.series.userOptions.data1[this.point.x]["ChangeVs"];
                  let sig = this.series.userOptions.data1[this.point.x]["Significance"];
                  let sig1 = this.series.userOptions.data1[this.point.x]["Significance2"];
                  let s = sig > 0 ? upwardTriangle : (sig < 0 ? downwardTriangle : '');
                  let changeColor = sig1 < 0 ? 'red' : (sig1 > 0 ? 'green' : properties.darkTheme ? "white" : "Black");
                  let sigcolor = sig > 0 ? 'green' : (sig < 0 ? 'red' : '');
                  let finalText = '<span>' + text +
                    (changeText ? '&nbsp<span style="color:' + ';"> ' +
                      '<span style="font-size: 80%; color:' + changeColor + ';">(' + changeText + ')</span>&nbsp' +
                      '<span style="color:' + sigcolor + ';">' + s + '</span>' : '') +
                    '</span>';
                  this.series.userOptions.tooltip[this.point.x] = finalText;
                  return (
                    finalText
                  );
                }

                if (properties.datalabelStyle == "lowSample") {
                  text = this.series.userOptions.data1[this.point.x]["Sample Size"] >= samplesizeConstantValue ? this.y + (ispercentage && '%') : 'LS';
                  let finalText = '<b>' +
                    text +
                    '</b> ' +
                    '<span style="opacity: 0.5"></span>';
                  this.series.userOptions.tooltip[this.point.x] = finalText;
                  return (
                    finalText
                  );
                }
                let finalText = this.y + (ispercentage && '%')
                this.series.userOptions.tooltip[this.point.x] = finalText;
                return finalText;
              }
            }
          }
        },
        series: this.seriesData,
      } as any);

      var chart = this.chart;
      var legendWidth = chart.legend.legendWidth;
      // Adjust margins based on the legend width

      if (this.ChartProperties.legendPosition == "left" && this.ChartProperties.showLegend) {
        this.chart.update({
          chart: {
            marginLeft: legendWidth + 50, // Add some extra space
            marginRight: 30
          }
        }, false);

      }

      if (this.ChartProperties.legendPosition == "right" && this.ChartProperties.showLegend) {
        this.chart.update({
          chart: {
            marginLeft: legendWidth + 5, // Add some extra space
            marginRight: legendWidth + 25
          }
        }, false);
      }
    }
  }

  // getTooltipValue(value:any,actualValue:any,sampleSize:any){
  //   if(sampleSize >= 1000){
  //     return actualValue == null ? 'NA' : value; 
  //   }
  //   return actualValue == null ? 'NA' : "LS";
  // }
  // prepareSeriesDataForChart() {
  //   if (this.isOutput) {
  //     this.seriesData = [];

  //     this.LineChartData = this.chartMainData;

  //     let metrics = _.uniqBy(this.LineChartData, 'Series Name').map((item) => {
  //       return item['Series Name'];
  //     });

  //     this.categoriesList = _.uniqBy(this.LineChartData, 'Category Name').map(
  //       (item) => {
  //         return item['Category Name'];
  //       }
  //     );

  //     let uniqueDataValue = _.uniqBy(this.LineChartData, 'Rounded Value').map(
  //       (item) => {
  //         return item['Rounded Value'];
  //       }
  //     );

  //     if (this.ChartProperties.datalabelStyle === 'lowSample') {
  //       this.showLowSample = true;
  //     } else {
  //       this.showLowSample = false;
  //     }

  //     let minValue = Math.min(...uniqueDataValue);
  //     let maxValue = Math.max(...uniqueDataValue);
  //     this.chartMinAxis = minValue;
  //     this.chartMaxAxis = maxValue + maxValue * 0.05;

  //     let idx = 0;
  //     let dataObject: any = {};
  //     let consumableData: any = [];
  //     let consumableData1: any = [];

  //     metrics.forEach((metric) => {
  //       dataObject = {};
  //       consumableData = [];
  //       consumableData1 = [];

  //       //let metricData = this.LineChartData.filter( res => res["Series Name"] == metric);
  //       let i = 0;
  //       this.categoriesList.forEach((item: any) => {
  //         let metricData: any;
  //         metricData = this.LineChartData.filter(
  //           (res) => res['Series Name'] == metric && res['Category Name'] == item
  //         )[0];
  //         if (!this.updateCategoryName.includes(metricData['Category Image'])) {
  //           this.updateCategoryName.push(metricData['Category Image']);
  //         }

  //         if (this.showLowSample) {
  //           if (metricData['Sample size'] < this._configService.ISthreshold) {
  //             consumableData.push({
  //               y: 0,

  //             });
  //           } else {
  //             consumableData.push({
  //               y:
  //                 metricData['Value'] == null
  //                   ? null
  //                   : Number(
  //                     parseFloat(metricData['Value']).toFixed(
  //                       this.ChartProperties.decimalRoundOff
  //                     )
  //                   ),
  //               indexValue: metricData['ValueForIndex'] == null
  //                 ? null
  //                 : Number(
  //                   parseFloat(metricData['ValueForIndex']).toFixed(
  //                     this.ChartProperties.decimalRoundOff
  //                   )
  //                 )
  //             });
  //           }
  //         } else {
  //           if (
  //             this._configService.userRole != 'superadmin' &&
  //             metricData['Sample size'] < this._configService.ISthreshold
  //           ) {
  //             consumableData.push({
  //               y: 0,
  //               cov: "I/S",
  //             });
  //           } else {
  //             consumableData.push({
  //               name: metric,
  //               y:
  //                 metricData['Value'] == null
  //                   ? null
  //                   : Number(
  //                     parseFloat(metricData['Value']).toFixed(
  //                       this.ChartProperties.decimalRoundOff
  //                     )
  //                   ),
  //               y1:
  //                 metricData['Value'] == null
  //                   ? null
  //                   : Number(
  //                     parseFloat(metricData['Value']).toFixed(
  //                       this.ChartProperties.decimalRoundOff
  //                     )
  //                   ),
  //               indexValue: metricData['ValueForIndex'] == null
  //                 ? null
  //                 : Number(
  //                   parseFloat(metricData['ValueForIndex']).toFixed(
  //                     this.ChartProperties.decimalRoundOff
  //                   )
  //                 ),
  //               cov: metricData['ChangeVs'],
  //               significance: metricData['Significance'],
  //               samplesize: metricData['Sample size'],
  //               significance2: metricData['Significance2'],
  //               tooltip: '',
  //               isPercentage: metricData['isPercentage'],
  //               Sig_LowerLimt: metricData['Sig_LowerLimt'],
  //               Sig_UpperLimt: metricData['Sig_UpperLimt'],

  //               // "Series Name": lev2.metricName,
  //               // "Category Name": dataArr.lvl1Child,
  //               // "Rounded Value": dataArr.data == null ? null : dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : dataArr.data,
  //               // "Value": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : dataArr.data,
  //               // "Label": dataArr.data == null ? "NA" : dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : dataArr.data,
  //               // "ChangeVs": dataArr.changeVsPY,
  //               // "Significance": "-1",
  //               // "Sample size": dataArr.baseValueforLSorIs,
  //               // "Significance2": "1",
  //               // "Category Image": "Category_Image_1",
  //               // "isPercentage": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? true : false,
  //               // "Sig_LowerLimt": this.Sig_LowerLimt,
  //               // "Sig_UpperLimt": this.Sig_UpperLimt
  //             });
  //           }
  //         }
  //         consumableData1.push(metricData);
  //         i++;
  //       });

  //       dataObject.name = metric;
  //       dataObject.color = this.colorCodeList[idx++];
  //       dataObject.data = consumableData;
  //       dataObject.data1 = consumableData1;
  //       dataObject.connectNulls = false;
  //       dataObject.tooltip = [];
  //       //dataObject.pointPlacement = "on";
  //       this.seriesData.push(dataObject);
  //     });
  //   }
  //   else {
  //     this.seriesData = [];

  //     let metrics = _.uniqBy(this.LineChartData, "Series Name").map(item => {
  //       return item["Series Name"];
  //     });

  //     this.categoriesList = _.uniqBy(this.LineChartData, "Category Name").map(item => {
  //       return item["Category Name"];

  //     })

  //     let uniqueDataValue = _.uniqBy(this.LineChartData, "Value").map(item => {
  //       return item["Value"];
  //     });

  //     if (this.ChartProperties.datalabelStyle === "lowSample") {
  //       this.showLowSample = true;
  //     } else {
  //       this.showLowSample = false;
  //     }

  //     let minValue = Math.min(...uniqueDataValue);
  //     let maxValue = Math.max(...uniqueDataValue);
  //     this.chartMinAxis = Math.floor(minValue - (minValue * 0.10));
  //     this.chartMaxAxis = Math.ceil(maxValue + (maxValue * 0.10));

  //     let idx = 0;
  //     let dataObject: any = {};
  //     let consumableData: any = [];
  //     let consumableData1: any = [];

  //     metrics.forEach((metric) => {
  //       dataObject = {};
  //       consumableData = [];
  //       consumableData1 = [];

  //       //let metricData = this.LineChartData.filter( res => res["Series Name"] == metric);
  //       let i = 0;
  //       this.categoriesList.forEach((item: any) => {
  //         let metricData: any;
  //         metricData = _.cloneDeep(this.LineChartData.filter(res => res["Series Name"] == metric && res["Category Name"] == item)[0]);
  //         metricData["Value"] = metricData["Value"] == null ? 0 : parseFloat(Number(_.cloneDeep(metricData["Value"])).toFixed(this.ChartProperties.decimalRoundOff));
  //         if (!this.updateCategoryName.includes(metricData["Category Image"])) {
  //           this.updateCategoryName.push(metricData["Category Image"]);
  //         }

  //         if (this.showLowSample) {
  //           if (metricData["Sample Size"] < this.samplesizeConstantValue) {
  //             consumableData.push({
  //               y: 0
  //             })
  //           } else {
  //             consumableData.push({
  //               y: metricData["Value"] == null ? 0 : metricData["Value"]
  //             })
  //           }
  //         } else {
  //           consumableData.push({
  //             y: metricData["Value"] == null ? 0 : metricData["Value"]
  //           })
  //         }
  //         consumableData1.push(metricData);
  //         i++;
  //       })

  //       dataObject.name = metric;
  //       dataObject.color = this.colorCodeList[idx++];
  //       dataObject.data = consumableData;
  //       dataObject.data1 = consumableData1;
  //       dataObject.tooltip = [];
  //       //dataObject.pointPlacement = "on";
  //       this.seriesData.push(dataObject);
  //     })
  //   }
  // }

   extractDisplayName(metricName: string): string {
    if (!metricName) return metricName;
    const parts = metricName.split('|');

    if (parts.length <= 1) {
      // No pipe separator, return as-is
      return metricName;
    }

    const firstPart = parts[0].trim();
    const metricGroupsToRemove = ['Familiarity', 'Imagery'];

    if (metricGroupsToRemove.some(group => firstPart === group)) {
     return parts[parts.length - 1].trim();
    } else {
     return parts.map((p: string) => p.trim()).join(' | ');
    }
  }

  prepareSeriesDataForChart() {
    this.seriesData = [];

    this.LineChartData = this.chartMainData;

    let metrics = _.uniqBy(this.LineChartData, 'Series Name').map((item) => {
      return item['Series Name'];
    });

    this.categoriesList = _.uniqBy(this.LineChartData, 'Category Name').map(
      (item) => {
        return item['Category Name'];
      }
    );

    let uniqueDataValue = _.uniqBy(this.LineChartData, 'Rounded Value').map(
      (item) => {
        return item['Rounded Value'];
      }
    );

    if (this.ChartProperties.datalabeadlStyle === 'lowSample') {
      this.showLowSample = true;
    } else {
      this.showLowSample = false;
    }

    let minValue = Math.min(...uniqueDataValue);
    let maxValue = Math.max(...uniqueDataValue);
    this.chartMinAxis = minValue;
    this.chartMaxAxis = maxValue + maxValue * 0.05;

    let idx = 0;
    let dataObject: any = {};
    let consumableData: any = [];
    let consumableData1: any = [];

    metrics?.forEach((metric) => {
      dataObject = {};
      consumableData = [];
      consumableData1 = [];
      //let metricData = this.LineChartData.filter( res => res["Series Name"] == metric);
      let i = 0;
      this.categoriesList?.sort((a: any, b: any) => a - b);
      this.categoriesList?.forEach((item: any) => {
        let metricData: any;
        metricData = this.LineChartData.filter(
          (res) => res['Series Name'] == metric && res['Category Name'] == item
        )[0];
        if (!metricData) return;
        if (metricData?.['Category Image'] && !this.updateCategoryName.includes(metricData?.['Category Image'])) {
          this.updateCategoryName.push(metricData['Category Image']);
        }

        if (this.showLowSample) {
          if (metricData?.['Sample size'] < this._configService.ISthreshold) {
            consumableData.push({
              y: 0,

            });
          } else {
            consumableData.push({
              y: this._configService.userRole != "superadmin" && Number(metricData?.['Sample size']) <= this._configService.ISthreshold ? 0 : (!this.showLowSample ? metricData?.['Value'] == null ? 0 : Number(parseFloat(metricData?.['Value']).toFixed(this.ChartProperties.decimalRoundOff)) : (parseFloat(metricData?.['Sample size']) > this.samplesizeConstantValue ? metricData?.['Value'] == null ? 0 : Number(parseFloat(metricData?.['Value']).toFixed(this.ChartProperties.decimalRoundOff)) : 0)),
               indexValue:metricData?.['ValueForIndex'] == null
              ? 'NA'
              : Number(
                parseFloat(metricData?.['ValueForIndex']).toFixed(
                  this.ChartProperties.decimalRoundOff
                )
              )
            });
          }
        } else {
          if (
            this._configService.userRole != 'superadmin' &&
            metricData?.['Sample size'] < this._configService.ISthreshold
          ) {
            consumableData.push({
              y: 0,
              cov: "I/S",
              Significance_Value: metricData['Significance_Value'],
            });
          } else {
            consumableData.push({
              name: metric,
              y: this._configService.userRole != "superadmin" && Number(metricData?.['Sample size']) <= this._configService.ISthreshold ? 0 : (!this.showLowSample ? metricData?.['Value'] == null ? 0 : Number(parseFloat(metricData['Value']).toFixed(this.ChartProperties.decimalRoundOff)) : (parseFloat(metricData?.['Sample size']) > this.samplesizeConstantValue ? metricData['Value'] == null ? 0 : Number(parseFloat(metricData['Value']).toFixed(this.ChartProperties.decimalRoundOff)) : 0)),
              y1:
                metricData?.['Value'] == null
                  ? null
                  : Number(
                    parseFloat(metricData['Value']).toFixed(
                      this.ChartProperties.decimalRoundOff
                    )
                  ),
                  indexValue:metricData?.['ValueForIndex'] == null
                  ? 'NA'
                  : Number(
                    parseFloat(metricData?.['ValueForIndex']).toFixed(
                      this.ChartProperties.decimalRoundOff
                    )
                  ),
              cov: metricData?.['ChangeVs'],
              significance: metricData?.['Significance'],
              samplesize: metricData?.['Sample size'],
              significance2: metricData?.['Significance2'],
              tooltip: '',
              color: metricData?.['color'],
              isPercentage: metricData?.['isPercentage'],
              Sig_LowerLimt: metricData?.['Sig_LowerLimt'],
              Sig_UpperLimt: metricData?.['Sig_UpperLimt'],
              Significance_Value: metricData?.['Significance_Value'],

              // "Series Name": lev2.metricName,
              // "Category Name": dataArr.lvl1Child,
              // "Rounded Value": dataArr.data == null ? null : dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : dataArr.data,
              // "Value": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : dataArr.data,
              // "Label": dataArr.data == null ? "NA" : dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : dataArr.data,
              // "ChangeVs": dataArr.changeVsPY,
              // "Significance": "-1",
              // "Sample size": dataArr.baseValueforLSorIs,
              // "Significance2": "1",
              // "Category Image": "Category_Image_1",
              // "isPercentage": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? true : false,
              // "Sig_LowerLimt": this.Sig_LowerLimt,
              // "Sig_UpperLimt": this.Sig_UpperLimt
            });
          }
        }
        consumableData1.push(metricData);
        i++;
      });

  // Use the helper function to extract the display name without metric group prefix
  const displayName = this.extractDisplayName(metric);
  dataObject.name = displayName;
  var met = displayName;
  // prefer a globally consistent color when available, otherwise use local palette
  const seriesColor = this.globalColorMap && this.globalColorMap[met] ? this.globalColorMap[met] : this.colorCodeList[idx++];
  dataObject.color = seriesColor;
      dataObject.data = consumableData;
      dataObject.data1 = consumableData1;
      dataObject.connectNulls = false;
      dataObject.tooltip = [];
      //dataObject.pointPlacement = "on";
      this.seriesData.push(dataObject);
    });
  }

  getDataValue(sampleSize: any, value: any) {

    if (sampleSize >= this.samplesizeConstantValue)
      return value;
    return 0;
  }

  userselectedproperties() {

    let linechartData = {
      data: this.LineChartData,
      Properties: [this.ChartProperties],
      title: this.data.title
    }
    return JSON.stringify(linechartData).toString();
  }
  customization(): Observable<any> {
      const snapshotTypeSelectedName = this._customSnapshotService.selectedSnapshotType?.name;
    const cohortType = snapshotTypeSelectedName && snapshotTypeSelectedName.toLowerCase().includes('audience') 
      ? this._configService.audienceCohortType 
      : 'NA';
    // return this.LineTrendService.Line1CustomizationList();
    return _.cloneDeep(this._customSnapshotService.getChartCustomization("Trend as Widget", snapshotTypeSelectedName, cohortType));

  }
  applycustomization(event: any, item: string) {
    this.event = event;
    //choose the appropriate customization
    this.LineTrendService.applycustomization(event, item, this.ChartProperties);
    localStorage.setItem('properties', JSON.stringify(this.ChartProperties));
    this.plotLineChart('chart-container' + this.id);
  }
}
